/**
 * LUXE COSMETICS - ADVERTORIAL PAGE JAVASCRIPT (v2)
 * Handles:
 * 1. Reading progress bar
 * 2. Sticky Add-to-Cart bar
 * 3. Recommendation card show/hide
 * 4. Smooth scroll behavior
 */

(function () {
  'use strict';

  /* ============================
     PROGRESS BAR
     ============================ */
  const progressWrap = document.getElementById('advProgressBar');
  const progressFill = document.getElementById('advProgressFill');

  function updateProgressBar() {
    if (!progressWrap || !progressFill) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    if (docHeight <= 0) return;

    const scrollPercent = Math.min((scrollTop / docHeight) * 100, 100);
    progressFill.style.width = scrollPercent + '%';

    if (scrollTop > 50) {
      progressWrap.classList.add('is-visible');
    } else {
      progressWrap.classList.remove('is-visible');
    }
  }

  /* ============================
     STICKY ATC BAR
     ============================ */
  const stickyAtc = document.getElementById('advStickyAtc');

  function updateStickyAtc() {
    if (!stickyAtc) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = scrollTop / docHeight;

    if (scrollTop > 600 && scrollPercent < 0.95) {
      stickyAtc.classList.add('is-visible');
    } else {
      stickyAtc.classList.remove('is-visible');
    }
  }

  /* ============================
     RECOMMENDATION CARD
     ============================ */
  const recCard = document.getElementById('advRecCard');

  function updateRecCard() {
    if (!recCard) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = scrollTop / docHeight;

    // Show between 5% and 90% scroll
    if (scrollTop > 200 && scrollPercent < 0.90) {
      recCard.classList.remove('is-hidden');
    } else {
      recCard.classList.add('is-hidden');
    }
  }

  /* ============================
     SCROLL HANDLER (throttled via rAF)
     ============================ */
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProgressBar();
        updateStickyAtc();
        updateRecCard();
        ticking = false;
      });
      ticking = true;
    }
  }

  /* ============================
     INIT
     ============================ */
  function init() {
    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial state
    updateProgressBar();
    updateStickyAtc();
    if (recCard) recCard.classList.add('is-hidden');
    updateRecCard();

    // Smooth scroll
    document.documentElement.style.scrollBehavior = 'smooth';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();